var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubtractingButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_671_8785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57135 17.9999C4.60863 17.9999 0.571289 13.9625 0.571289 8.99994C0.571289 4.03734 4.60863 0 9.57135 0C14.5339 0 18.5713 4.03734 18.5713 8.99994C18.5713 13.9625 14.5339 17.9999 9.57135 17.9999ZM9.57135 1.4754C5.42223 1.4754 2.04669 4.85088 2.04669 8.99994C2.04669 13.1491 5.42223 16.5245 9.57135 16.5245C13.7204 16.5245 17.0959 13.1491 17.0959 8.99994C17.0959 4.85088 13.7204 1.4754 9.57135 1.4754Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4346 9.73761H6.5752C6.16781 9.73761 5.3877 9.40733 5.3877 9C5.3877 8.59261 6.16781 8.26221 6.5752 8.26221H12.4346C12.842 8.26221 13.3877 8.59261 13.3877 9C13.3877 9.40733 12.842 9.73761 12.4346 9.73761Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_671_8785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.571289)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractingButton);
export default __webpack_public_path__ + "static/media/subtracting-button.0b31d92503753f43f1c805a62fe7cd22.svg";
export { ForwardRef as ReactComponent };